module.exports = __webpack_public_path__ + "static/00071.bf96cf07.jpg";